<template>
  <div class="recordIOSettings">
    <div class="lineInput">
      <w-select icon="microphone" :label="$t('settings.panel.audio')" :value="microphoneSelected"
                @input="selectMicrophone">
        <option :value="audio.deviceId" v-for="audio of listOfDeviceAudio"
                :key="'audio'+audio.deviceId">{{ audio.label }}
        </option>
      </w-select>
    </div>
    <div class="lineInput">
      <w-select icon="video" :label="$t('settings.panel.video')" :value="cameraSelected" @input="selectCamera">
        <option :value="video.deviceId" v-for="video of listOfDeviceVideo"
                :key="'videoDevice'+video.deviceId">{{ video.label }}
        </option>
      </w-select>
    </div>

    <div class="lineInput">
      <w-select icon="cogs" :label="$t('settings.panel.captureQuality')" :value="resolutionSelected"
                @input="chooseResolution">
        <option :value="res.value" v-for="(res,index) in listOfResolution"
                :key="'resolution'+index"> {{ res.label }}
        </option>
      </w-select>
    </div>
    <div class="lineInput">
      <w-select icon="cogs" :label="$t('settings.panel.captureFps')" :value="fpsSelected"
                @input="chooseFps">
        <option :value="fps.value" v-for="(fps,index) in listOfFps"
                :key="'fps'+index"> {{ fps.label }}
      </option>
      </w-select>
    </div>
    <div class="lineInputNoiseCancelling">
      <div class="labelNoiseCancelling">
        {{ $t('settings.panel.removeNoise') }}
      </div>
      <div class="switchNoiseCancelling">
        <w-switch :value="getNoiseCancelationLvl>0" @input="setNoiseCancelelation" size="small"/>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from 'vue-property-decorator';
import store from '@/store';
import WSelect from '@/components/wrapper/w-select.vue';
import WSwitch from '@/components/wrapper/w-switch.vue';
import {SETUP_FAVORITE_MICROPHONE, SETUP_FAVORITE_WEBCAM} from '@/store/setup/setupAction';
import {setActionEvent} from '@/utils/tracker';
import {ActionEvent} from '@/enum/TrackerEnum';
import {SettingUsersKey} from '@/store/settingUsers/settingUserKey';
import {SET_SETTINGUSER, SettingUserParams} from '@/store/settingUsers/settingUserAction';

@Component({
  components: {WSwitch, WSelect},
})
export default class RecordIOSettings extends Vue {
  private listOfDeviceAudio: InputDeviceInfo[] = [];
  private listOfDeviceVideo: InputDeviceInfo[] = [];

  public mounted() {
    this.getDevices();
  }

  public async getDevices() {
    const devices = await navigator.mediaDevices.enumerateDevices();
    for (const device of devices) {
      if (device.kind === 'audioinput') {
        this.listOfDeviceAudio.push(device as InputDeviceInfo);
      }
      if (device.kind === 'videoinput') {
        this.listOfDeviceVideo.push(device as InputDeviceInfo);
      }
    }
  }

  public selectMicrophone(deviceID: string) {
    store.dispatch(SETUP_FAVORITE_MICROPHONE, deviceID);
    setActionEvent(ActionEvent.setting_microphone_change);
  }

  public selectCamera(deviceID: string) {
    store.dispatch(SETUP_FAVORITE_WEBCAM, deviceID);
    setActionEvent(ActionEvent.setting_webcam_change);
  }

  get listOfResolution() {
    return [{value: 720, label: this.$t('resolution.720')},
      {value: 1080, label: this.$t('resolution.1080')},
      {value: 1440, label: this.$t('resolution.1440')},
      {value: 2160, label: this.$t('resolution.2160')}];
  }

  get listOfFps() {
    return [{value: 25, label: this.$t('fps.25')},
      {value: 30, label: this.$t('fps.30')},
      {value: 60, label: this.$t('fps.60')}];
  }

  get resolutionSelected() {
    return store.getters.getResolutionCapture;
  }

  get fpsSelected() {
    return store.getters.getFpsCapture;
  }

  public chooseResolution(value) {
    const params = new SettingUserParams(SettingUsersKey.CAPTURE_RESOLUTION, value);
    store.dispatch(SET_SETTINGUSER, params).then(() => {
      setActionEvent(ActionEvent.setting_capture_quality,
          {capture_quality: value});
    });
  }

  public chooseFps(value) {
    const params = new SettingUserParams(SettingUsersKey.CAPTURE_FPS, value);
    store.dispatch(SET_SETTINGUSER, params).then(() => {
      setActionEvent(ActionEvent.setting_capture_quality,
          {capture_quality: value});
    });
  }

  get getNoiseCancelationLvl() {
    return store.getters.getNoiseCancelationLvl;
  }

  public setNoiseCancelelation(value: boolean) {

    let valueToSet = 0;
    if (value) {
      valueToSet = 1;
    }
    const params = new SettingUserParams(SettingUsersKey.NOISE_CANCELATION, valueToSet);
    store.dispatch(SET_SETTINGUSER, params).then(() => {
      setActionEvent(ActionEvent.setting_noise_cancelation,
          {value_noise_cancelation: valueToSet});
    });
  }

  get cameraSelected() {
    if (store.getters.getFavoriteCamera === '' && this.listOfDeviceVideo.length > 0) {
      return this.listOfDeviceVideo[0].deviceId;
    }
    return store.getters.getFavoriteCamera;
  }

  get microphoneSelected() {
    if (store.getters.getFavoriteMicro === '' && this.listOfDeviceVideo.length > 0) {

      return this.listOfDeviceAudio[0].deviceId;
    }
    return store.getters.getFavoriteMicro;
  }
}
</script>

<style scoped lang="scss">
.recordIOSettings {
  color: #1B3954;

  .lineInput {
    margin-top: 24px;
  }

  .lineInputNoiseCancelling {
    display: flex;
    margin-top: 24px;

    .labelNoiseCancelling {
      display: flex;
      flex: 1;
      font-size: 16px;
      color: var(--black);
    }

    .switchNoiseCancelling {
      display: flex;
      margin-right: -8px;
    }
  }
}
</style>
